export const BASE_URL_STAGING =
  "https://voicelip-backend-staging.herokuapp.com";

export const BASE_URL_PRODUCTION = "https://voicelip-production.herokuapp.com";
